export const CONFIG = {
  stage: process.env.REACT_APP_STAGE!,
  baseApiUrl: process.env.REACT_APP_BASE_API_URL!,
};

export const AWS_CONFIG = {
  Auth: {
    region: process.env.REACT_APP_AWS_REGION!,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID!,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID!,
    oauth: {
      domain: process.env.REACT_APP_AWS_OAUTH_DOMAIN!,
      scope: process.env.REACT_APP_AWS_OAUTH_SCOPE!.split(","),
      redirectSignIn: process.env.REACT_APP_AWS_OAUTH_REDIRECT_SIGNIN!,
      redirectSignOut: process.env.REACT_APP_AWS_OAUTH_REDIRECT_SIGNOUT!,
      responseType: process.env.REACT_APP_AWS_OAUTH_RESPONSE_TYPE!,
    },
  },
};

export const INTEGRATION_TOOL = {
  bitbucket: process.env.REACT_APP_INTEGRATION_TOOL_BITBUCKET!,
};

export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY!;

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY!;

export const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_KEY!;
export const JUNEIFY_KEY = process.env.REACT_APP_JUNEIFY_KEY!;

export const CODEGEN_SERVER_URL = process.env.REACT_APP_CODEGEN_SERVER_URL!;

export const ENABLE_MONITOR_MODE =
  process.env.REACT_APP_ENABLE_MONITOR_MODE === "true";

export const ENABLE_BILLING_MODE =
  process.env.REACT_APP_ENABLE_BILLING_MODE === "true";
